import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IFormController, IQService, IRootScopeService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {gettextCatalog} from "angular-gettext";
import {Autentisering} from "felles/tjenester/Autentisering";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {InnlastingsindikatorKontroller} from "web/moduler/basis/direktiver/innlastingsindikator";
import {GruppeInvitasjonRessurs} from "felles/tjenester/ressurser/GruppeInvitasjonRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {Kontekst} from "felles/tjenester/Kontekst";
import {Tidssonevalg} from "../../../../felles/tjenester/i18n/Tidssonevalg";
import {Språkvalg} from "../../../../felles/tjenester/i18n/Spraakvalg";
import {Logger} from "felles/infrastruktur/Logging";
import {Debugger} from "debug";

const scss = require('./invitasjon.scss');
const debug:Debugger = require('debug')('GodtaInvitasjonKontroller');

export class GodtaInvitasjonKontroller {

    static regNavn = "web.GodtaInvitasjonKontroller";

    static forInjisering() {
        return [
            regNavn.ng.ui.$stateParams,
            regNavn.ng.$q,
            regNavn.ng.$rootScope,
            GruppeInvitasjonRessurs.regNavn,
            Autentisering.regNavn,
            Kontekst.regNavn,
            WebNavigasjon.regNavn,
            Språkvalg.regNavn,
            Tidssonevalg.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            Logger.regNavn,
            GodtaInvitasjonKontroller
        ]
    }

    constructor(private $stateParams: any,
                private $q: IQService,
                private $rootScope: IRootScopeService,
                private invitasjonsRes: GruppeInvitasjonRessurs,
                private autentisering: Autentisering,
                private kontekst: Kontekst,
                private navigasjon: WebNavigasjon,
                private språkvalg: Språkvalg,
                private tidssonevalg: Tidssonevalg,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private logger:Logger) {
        this.init();
    }

    modell = new NyKontomodell();
    invitasjon: l.GruppeInvitasjonTilGodkjenningModell;

    lasterInvitasjon = true;
    gyldigInvitasjon = false;

    lagrer = false;
    steg: 'ugyldig_invitasjon' | 'send_otp' | 'angi_otp' | 'metode_logginn' | 'metode_nykonto' = null;

    // Når bruker ikke har/ønsker å bruke eid, viser da passordskjema
    brukerIkkeOnskerABrukeEid = false;

    // Når bruker har valgt å autentisere seg med eid
    eidValgt = false;

    // må bruke popup (som betyr nytt vindu) for at callback skal bli kalt.
    criiptoGuiModus = l.CriiptoGuiModus.popup;

    sendOtp() {
        this.lagrer = true;
        this.invitasjonsRes.sendOtp(this.$stateParams.token).$promise
            .then(respons => {
                this.modell.otpSendtTil = respons.otpSmsSendtTil
                this.steg = 'angi_otp';
            })
            .finally(() => this.lagrer = false);
    }

    sendNyOtp(){
        this.lagrer = true;
        this.modell.spesifikasjon.engangskode = null
        this.invitasjonsRes.sendOtp(this.$stateParams.token).$promise
            .then(respons => {
                this.modell.otpSendtTil = respons.otpSmsSendtTil
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Ny engangskode er sendt til din mobiltelefon'))
            })
            .finally(() => this.lagrer = false);
    }

    otpOppdatert(){
        this.modell.otpKodeValidert = true;
    }

    validerOtp() {
        this.lagrer = true;
        this.invitasjonsRes.validerOtp(this.$stateParams.token, this.modell.spesifikasjon.engangskode).$promise
            .then(respons => {
                this.modell.otpKodeValidert = respons.otpValidert;
                if (respons.otpValidert) this.steg = 'metode_nykonto';
            })
            .finally(() => this.lagrer = false);
    }

    velgLoggInn(){
        this.steg = 'metode_logginn';
    }

    avbryt(){
        this.brukerIkkeOnskerABrukeEid = false;
        this.gåTilInitieltSteg();
    }

    jegHarIkkeBankid() {
        this.brukerIkkeOnskerABrukeEid = true;
    }

    vedEidValgt() {
        this.eidValgt = true;
    }

    godtaInvitasjon(skjema: IFormController) {
        this.lagrer = true;
        this.$rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
        this.invitasjonsRes.godtaInvitasjonTilNyBruker(this.modell.spesifikasjon).$promise
            .catch(() => {
                return this.$q.reject();
            })
            .then(() => this.autentisering.autentiser(this.modell.somInnloggingspesifikasjon())
            )
            .then(autentisert => {
                this.reset();
                this.navigasjon.gåTilInvitasjonGodtatt();
            })
            .finally(() => {
                this.lagrer = false;
                this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
                skjema.$setPristine()
            });
    }

    /** Godtar invitasjonen fra jwt-token bruker fikk ved autentisering */
    autentisert(autentisert:l.AutentisertOkModell){
        this.invitasjonsRes.godtaInvitasjonFraTokenSomEksisterendeBruker(this.$stateParams.token, this.modell.spesifikasjon.engangskode).$promise
            .then(()=> {
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Gratulerer, du har nå tilgang til {{gruppetittel}} i {{organisasjonsnavn}}', {gruppetittel:this.invitasjon.gruppeTittel, organisasjonsnavn: this.invitasjon.gruppeOrganisasjonsnavn}))
                this.kontekst.relastBrukerOgGrupper();
                this.navigasjon.gåTilForespurtEllerStartsiden();
            })
    }

    /** Vi får tilbake subject fra criipto-komponenten, bruker denne videre til å binde konto og logge inn brukeren */
    vedCriiptoBrukerIkkeFunnet(subject: l.SubjectIdIkkeKnyttetTilBrukerModell) {
        this.godtaInvitasjonOgBindEid(subject)
    }
    vedCriiptoAvbrutt(){
        debug("criiptoAvbryt")
        this.gåTilInitieltSteg();
    }

    vedCriiptoFeil(feil:any){
        debug("criiptoFeil", feil)
        this.logger.error(feil)
        this.meldingTilBruker.feilmelding(this.gettextCatalog.getString("Det oppstod en feil ved forsøk på å autentisere deg eId. Prøv på nytt"))
        this.gåTilInitieltSteg();
    }

    //hjelpemetoder

    private init(){
        this.navigasjon.registrerEventueltForespurtSide();
        this.modell = new NyKontomodell();
        this.invitasjonsRes.finnInvitasjon(this.$stateParams.token, this.$stateParams.medlemId, () => true).$promise //vi håndterer feilen i catch
            .then(invitasjonStatus => {
                // Welcome to the party! Invitasjonen er gyldig, og vi kan starte brukerregistrering
                if(invitasjonStatus.erGyldig) {
                    this.invitasjon = invitasjonStatus.invitasjon;
                    this.modell.spesifikasjon.token = this.$stateParams.token;
                    this.modell.spesifikasjon.brukernavnOgEpost = invitasjonStatus.invitasjon.epost;
                    this.modell.spesifikasjon.spraak = this.språkvalg.aktivtSpråk().servertag;
                    this.modell.spesifikasjon.tidssone = this.tidssonevalg.aktivTidssone();
                    this.gyldigInvitasjon = true;
                    return this.gåTilInitieltSteg();
                }

                // Invitasjonen har resultert i en bruker (dette kan vi kun finne når ?medlemId er satt)
                if(invitasjonStatus.harBruker) {

                    // Benyttet lenke hadde også en ?forespurtSide= (f.eks. fra møteinnkalling sendt til medlem uten bruker)
                    // Send brukeren til
                    // - riktig side hvis innlogget,
                    // - eller hvis utlogget, send til startsiden (hvor brukeren blir videresendt til riktig side etter innlogging)
                    if(this.navigasjon.harForespurtSide()) {
                        return this.navigasjon.gåTilForespurtEllerStartsiden();
                    }

                    // Brukeren trykket på invitasjon-eposten etter å ha opprettet bruker.
                    // Virker unødvendig, og det er det, men brukere er brukere. Send de dit de skal uten no mer fuzz
                    return this.navigasjon.gåTilStartsiden();
                }

                // Sad face: invitasjonen er ugyldig. Gjelder:
                // - i hovedsak gamle invitasjoner, hvor medlemId ikke er satt
                // - invitasjoner som utløp før brukeren trykket på lenken
                this.steg = 'ugyldig_invitasjon';
            })
            .catch(e => {
                // Vi hadde bare token å gå etter (?medlemId ikke satt),
                // og invitasjonen har utløpt, blitt brukt eller aldri eksisterte 👻
                this.steg = 'ugyldig_invitasjon';
            })
            .finally(() => this.lasterInvitasjon = false)
    }

    private godtaInvitasjonOgBindEid(subject:l.SubjectIdIkkeKnyttetTilBrukerModell) {
        let spesifikasjon: l.GodtaInvitasjonTilNyBrukerFraOpenidSubjectSpesifikasjon = {
            brukernavnOgEpost: this.invitasjon.epost,
            spraak: this.språkvalg.aktivtSpråk().servertag,
            tidssone: this.tidssonevalg.aktivTidssone(),
            invitasjonstoken: this.invitasjon.token,
            engangskode: this.modell.spesifikasjon.engangskode,
            criiptoSpesifikasjon: {
                kryptertOpenIdIdentitet: subject.kryptertOpenIdIdentitet,
                tokenvarighet: subject.tokenvarighet,
            }
        }

        this.invitasjonsRes.godtaInvitasjonTilNyBrukerFraSubject(spesifikasjon).$promise
          .then(response => {
              this.autentisering.lokalLoggUt()
              return this.autentisering.brukerAutentisertMotServer(response.autentisertBruker);
          })
          .then(() => {
              this.reset();
              return this.navigasjon.gåTilInvitasjonGodtatt();
          })
          .finally(() => {
              this.lagrer = false;
              this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
          });
    }


    private gåTilInitieltSteg(){
        this.steg = this.invitasjon.kreverOtpGodkjenning ? 'send_otp' : 'metode_nykonto';
    }

    private reset() {
        this.modell = new NyKontomodell();
    }
}


class NyKontomodell {
    otpSendtTil: string;
    otpKodeValidert = true;
    spesifikasjon: l.GodtaInvitasjonTilNyBrukerSpesifikasjon = {
        brukernavnOgEpost: '',
        passord: '',
        engangskode: '',
        token: '',
        spraak: null,
        tidssone: null
    };

    somInnloggingspesifikasjon(): l.InnloggingsSpesifikasjon {
        return {
            brukernavn: this.spesifikasjon.brukernavnOgEpost,
            passord: this.spesifikasjon.passord
        }
    }
}
